import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=7f602188&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"
import style0 from "./Vip.vue?vue&type=style&index=0&id=7f602188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f602188",
  null
  
)

export default component.exports